import React, { useState } from "react";
import "../About/FAQs.css";

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    // {
    //   question: "Does Impact Stories Fund invest in the projects?",
    //   answer:
    //     "Our mission is to amplify these stories, showcasing the tangible impact of social initiatives and inspiring action among donors, volunteers, and communities.",
    // },
    // {
    //   question: "Why does Impact Stories Fund invest in stories only?",
    //   answer:
    //     "Through our efforts, we aim to bridge the gap between numbers and human experiences, empowering stakeholders to see the profound difference their support makes.",
    // },
    // {
    //   question: "Why is the expected outcome of telling these stories?",
    //   answer:
    //     "Together, we can transform lives one story at a time, fostering a culture of compassion and collaboration for a better future. We aim to bring the stories we film to be viewed by stakeholders who wish to support the projects.",
    // },
    {
      question: "Who funds ISF? ",
      answer:
        "Impact Stories Fund is funded by SPARK Publicity and benefits from the filming services of www.papricut.com",
    },
    {
      question: "How can organisations and individuals partner with ISF?",
      answer:
        "Organisations can partner with Impact Stories Fund by sending proposals to info@impactstoriesfund.org.",
    },
    {
      question: "How can Individuals or Organisations donate to ISF?",
      answer:
        "At the moment Impact Stories Fund does not accept donations from individuals or organisations.",
    },
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="faq-container-wrapper mb-4">
      <div className="faq-section">
        <h2 className="faq-title">Frequently Asked Questions</h2>
        <br />
        <div className="faq-container">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="faq-item"
              onClick={() => toggleFAQ(index)}
            >
              <div className="faq-question">
                <h5>{faq.question}</h5>
                <div className="faq-icon">
                  {openIndex === index ? "-" : "+"}
                </div>
              </div>
              {openIndex === index && (
                <p className="faq-answer">{faq.answer}</p>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQSection;
